import React from 'react';
import type { ProjectMeta } from '../../data/types';

export type ProjectPageComponent = React.ComponentType<{ project: ProjectMeta }>;

const TimeToGoProject = React.lazy(() => import('./TimeToGoProject'));
const EchoProject = React.lazy(() => import('./EchoProject'));
const WechatVideoWorkflowProject = React.lazy(() => import('./WechatVideoWorkflowProject'));
const ComingSoonProject = React.lazy(() => import('./ComingSoonProject'));

export const projectRegistry: Readonly<Record<string, ProjectPageComponent>> = {
  timetogo: TimeToGoProject,
  echo: EchoProject,
  toki: ComingSoonProject,
  aitourism: ComingSoonProject,
  'wechat-video-workflow': WechatVideoWorkflowProject,
  'fashion-videogen': ComingSoonProject,
  ai4u: ComingSoonProject,
  shadowing: React.lazy(() => import('./ShadowingProject')),
};
